
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../user.service'
import { BASEMysqlService } from './_base';
import { MysqlServiceAziende } from './aziende';
import { MysqlServiceUsers } from './utenti';
import { MysqlServiceSedi } from './sedi';
import { MysqlServiceTipiCorso } from './tipi_corso';
import { MysqlServiceProgetti } from './progetti';
import { MysqlServiceLezioni } from './lezioni';
import { MysqlServiceCorsi } from './corsi';
import { MysqlServiceUtentiCorsi } from './utenti_corsi';
import { MysqlServiceUtentiLezioni } from './utenti_lezioni';
import { MysqlZoom } from './zoom';
import { MysqlServiceDashboard } from './dashboard';
import { MysqlServiceCorsiChat } from './corsi_chat';
import { MysqlServiceQuiz } from './quiz';
import { MysqlServiceLezioniQuiz } from './lezioni_quiz';
import { MysqlServiceLezioniQuizUtenti } from './lezioni_quiz_utenti';
import { MysqlServiceConti } from './conti';



@Injectable()
export class MysqlService extends BASEMysqlService {

  prefix = ''

  public users = new MysqlServiceUsers(this.http, this.router, this.userService)
  public aziende = new MysqlServiceAziende(this.http, this.router, this.userService)
  public sedi = new MysqlServiceSedi(this.http, this.router, this.userService)
  public tipi_corso = new MysqlServiceTipiCorso(this.http, this.router, this.userService)
  public progetti = new MysqlServiceProgetti(this.http, this.router, this.userService)
  public lezioni = new MysqlServiceLezioni(this.http, this.router, this.userService)
  public corsi = new MysqlServiceCorsi(this.http, this.router, this.userService)
  public utenti_corsi = new MysqlServiceUtentiCorsi(this.http, this.router, this.userService)
  public utenti_lezioni = new MysqlServiceUtentiLezioni(this.http, this.router, this.userService)
  public zoom = new MysqlZoom(this.http, this.router, this.userService)
  public dashboard = new MysqlServiceDashboard(this.http, this.router, this.userService)
  public corsi_chat = new MysqlServiceCorsiChat(this.http, this.router, this.userService)
  public quiz = new MysqlServiceQuiz(this.http, this.router, this.userService)
  public lezioni_quiz = new MysqlServiceLezioniQuiz(this.http, this.router, this.userService)
  public lezioni_quiz_utenti = new MysqlServiceLezioniQuizUtenti(this.http, this.router, this.userService)
  public conti = new MysqlServiceConti(this.http, this.router, this.userService)

  constructor(http: HttpClient, router: Router, userService: UserService) {
    super(http, router, userService)
  }

  isTest() {
    return this.URL_BASE.includes('-test');
  }

  send_mail(msg): Promise<any> {

    let data = {
      auth: this.userService.getCurrentUser(),
      data: msg
    }

    return this.http.post(this.URL_BASE + 'mail_send', data).toPromise();
  }


  get_attachmenmt_url(path: string, ext: string, fout: string): string {

    return this.URL_BASE + `get_attachment&path=${path}&ext=${ext.toLocaleLowerCase()}&fout=${fout}`

  }


}
